import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientMonitorlistComponent } from './client-monitorlist.component';

const routes: Routes = [ { path: '', component: ClientMonitorlistComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientMonitorlistRoutingModule { }
